import { useMutation } from '@tanstack/react-query';

import { RequestConfig } from '~/common/services/requests';
import { LoginData } from '../../../../types/requests';
import { handleError } from '../../../../utils/admin';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { getApiErrorMessage } from '../../../logic';
import { ApiErrorResponse } from '../../../types';
import { postLogin } from '../../requests/postLogin';

type LoginVariables = {
  data: LoginData;
  headers?: Record<string, string>;
  params?: RequestConfig['params'];
};

export const useLogin = () => {
  const { constructPost } = useRequestConstructor();
  const { mutateAsync, ...rest } = useMutation({
    mutationFn: ({ data, headers, params }: LoginVariables) =>
      postLogin(constructPost, data, headers, params),
    onError: (error: ApiErrorResponse) =>
      handleError(getApiErrorMessage(error, 'Login failed.')),
  });
  return { login: mutateAsync, ...rest };
};
